export const featuredTestimonials = [
  {
    initials: 'MR',
    text: 'It saved me so much time. I walked into Monday fully prepared, no scrambling. Highly recommend it.',
    author: 'Marcos R.',
    role: 'Functional Coach · Mexico',
    bg: 'bg-blue-600',
  },
  {
    initials: 'CP',
    text: 'I had my doubts before buying, but it surprised me. With the three versions I handle mixed-level groups with zero stress.',
    author: 'Carolina P.',
    role: 'Instructor · Colombia',
    bg: 'bg-cyan-600',
  },
  {
    initials: 'DG',
    text: 'I put a class together in 10 minutes and it shows. For what it costs, I recommend it without hesitation.',
    author: 'Diego G.',
    role: 'Boxing Coach · Peru',
    bg: 'bg-blue-600',
  },
]

export const coachTestimonials = [
  {
    initials: 'LM',
    name: 'Luciana M.',
    location: 'Chile',
    text: 'I used to show up to Monday exhausted. Now I open the volume and in 5 minutes my class is ready.',
    bg: 'bg-blue-600',
  },
  {
    initials: 'JP',
    name: 'Juan P.',
    location: 'Colombia',
    text: "I bought it a little skeptical and it surprised me: it's far more complete than I expected.",
    bg: 'bg-cyan-600',
  },
  {
    initials: 'VR',
    name: 'Valeria R.',
    location: 'Mexico',
    text: 'The warm-ups and class closers saved me. You can tell every class has structure from start to finish.',
    bg: 'bg-blue-600',
  },
  {
    initials: 'FA',
    name: 'Federico A.',
    location: 'Uruguay',
    text: 'It saved me so much time. I no longer lose my Sundays building sessions. Highly recommend it.',
    bg: 'bg-cyan-600',
  },
]
